// @flow

import React, { type Node } from 'react';

import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import { Separator } from '../../../../commons/atoms';

import { SpeiTicket } from './spei-ticket';
import { SpeiInstructions } from './spei-instructions';
import { AccountInfo } from './account-info';
import { SaveInstructionsButton } from './save-instructions-button';

export function SpeiPendingPage(): Node {
  const allFeatures = useAllFeatures();

  return (
    <>
      <p>Usa los siguientes datos para completar tu compra:</p>

      <SpeiTicket allFeatures={allFeatures} />

      <AccountInfo />

      <Separator size=".5em" pattern="dotted" />

      <IfFeature allFeatures={allFeatures} wanted="display_spei_instructions">
        <SpeiInstructions />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="action_spei_save_pdf">
        <SaveInstructionsButton />
      </IfFeature>
    </>
  );
}
